@for (notification of notifications; track notification) {
  <div>
    @if (showNotification(notification.filter)) {
      <div class="notification d-flex jcc aic p-m mb-m" [ngClass]="notification.type">
        @if (notification.type==='info') {
          <mat-icon fontSet="material-symbols-outlined" color="neutral" aria-hidden="false">info</mat-icon>
        }
        @if (notification.type==='warn') {
          <mat-icon fontSet="material-symbols-outlined" color="primary" aria-hidden="false">error</mat-icon>
        }
        @if (notification.type==='xmass') {
          <mat-icon fontSet="material-symbols-outlined" color="primary" aria-hidden="false">redeem</mat-icon>
        }
        <div  [innerHTML]="notification.text" class="flex-1 ml-m"></div>
      </div>
    }
  </div>
}
